module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-bottom.dec2de71.svg";